import CreateFilterModal from './CreateFilterModal'

export default CreateFilterModal;
